<template>
  <div>
    <router-view />
  </div>
</template>

<script>
const wx = require("weixin-js-sdk");
import mixUmeng from "./mixUmeng";
export default {
  mixins: [mixUmeng],
  name: "App",
  data() {
    return {};
  },
  created() {
    localStorage.clear("endCount");
    console.log(mixUmeng);
  },
  mounted() {
    console.log(mixUmeng);
    this.Forward();

    // var ua = navigator.userAgent.toLowerCase();
    // var isWeixin = ua.indexOf("micromessenger") != -1;
    // if (isWeixin) {

    // }
  },
  methods: {
    // 转发
    Forward() {
      var that = this;
      let uri = window.location.href.split("#")[0];

      uri = encodeURIComponent(uri);
      console.log(uri);
      that
        .$http({
          url: "wxshare/sharedata",
          method: "post",
          data: {
            uri: uri,
          },
        })
        .then((res) => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: [
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
            ], // 必填，需要使用的JS接口列表
          });

          wx.ready(function () {
            // 分享好友

            wx.onMenuShareAppMessage({
              title: res.data.title, // 分享标题
              desc: res.data.desc, // 分享描述
              link: "https://m.xstarlife.com", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: res.data.shareImg, // 分享图标
              success: function () {},
              cancel: function () {
                // 用户取消分享后执行的回调函数
              },
            });

            // + "&user_id=" + user_id
            // 分享朋友圈

            wx.onMenuShareTimeline({
              title: res.data.title, // 分享标题

              link: "https://m.xstarlife.com", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: res.data.shareImg, // 分享图标
              success: function () {
                // 设置成功
                this.$layer.toast({
                  // 图标clssName 如果为空 toast位置位于下方,否则居中
                  content: "分享成功",
                  time: 2000, // 自动消失时间 toast类型默认消失时间为2000毫秒
                });
              },
            });
          });
        })
        .catch((error) => {
          console.log(error.error);
          // Toast(error.error);
        });
      // SDK
    },
  },
};
</script>

<style>
.ratio-2x {
  padding: 0;
  margin: 0;
}

body {
  margin: 0 auto !important;
}
.layui-m-layermain,
.layui-m-layermain .layui-m-layersection {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  border: none !important;
}
.layui-m-layermain .layui-m-layersection {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  border: none !important;
}
.layui-m-layer0 .layui-m-layerchild {
  border-radius: 15px !important;
  width: 85% !important;
  padding-top: 20px 0 !important;
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  border: none !important;
}
.layui-m-layercont {
  padding: 15px !important;
  line-height: 22px !important;
  text-align: center !important;
  font-size: 15px !important;
  color: #666 !important;
  border: none !important;
}
.layui-m-layerbtn {

  width: 100% !important;
  background-color: #fff !important;
  border: none !important;
  border-radius:   0 0  15px 15px !important;
}
.layui-m-layerbtn span {
    
  background-color: #fff !important;
  font-size: 16px !important;
  border-radius: 10000px !important;
  color: #ff7d41 !important;
  display: block !important;
  border: none !important;
 
}
.clearfix:before {
  /*清除浮动*/
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue